<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import { Col, Container, Row } from "sveltestrap";
  import { Button } from "sveltestrap";
</script>

<div class="smart-main">
  <img
    src="/images/system/smartfarm/smartfarm_product1.jpg"
    alt="스마트팜 이미지1"
  />
  <Spacer size="5rem" />
  <div class="video" style="margin-top: 5px;">
    <div
      class="ytvideo-container"
      style="
  position: relative;
 
  margin: auto;
  height: auto;
  padding-top: 51%;
  "
    >
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/nS95eZ4MeL0"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen=""
        style="z-index: 1; top: 0; left: 0; position: absolute; width: 100%; height: 100%;"
      />
    </div>
  </div>
  <Spacer size="5rem" />
  <!-- <img
    src="/images/system/smartfarm/smartfarm_product2.jpg"
    alt="스마트팜 이미지2"
  /> -->
</div>

<!-- <div class="main" style="margin: auto; text-align: center; display: none;">
  <div class="section1">
    <div class="bandiimage">
      <img src="/images/system/smartfarm/1/head1.png" alt="헤드1" />
    </div>
    <div class="bandiimage">
      <img src="/images/system/smartfarm/1/head2.png" alt="헤드2" />
    </div>
    <Spacer size="3rem" />
    <h1 style="color: #0067a3;">농장관리</h1>
    <p class="basicText">
      <span
        >아직도, 대충 감으로 하십니까?<br />아니면 체계적으로 하시겠습니까?</span
      >
    </p>
    <Spacer size="2rem" />
  </div>
  <div class="section2">
    <Spacer size="8.125rem" />
    <h2 class="bold" style="color: #3cb043;">
      농가의 문제점을 체계적으로 관리하는<br /><br />
    </h2>
    <h2 class="bold">
      스마트 팜의 핵심 <span class="bandi_color" style="color: #0067a3;"
        >원격제어</span
      > 시스템!
    </h2>

    <span class="basicText"
      >반딧불이 시스템으로 농가를<br />체계적으로 관리합니다.</span
    >
    <Spacer size="7rem" />
    <div class="sys">
      <img src="/images/system/smartfarm/1/system1.png" alt="시스템1" />
      <img src="/images/system/smartfarm/1/system2.png" alt="시스템2" />
    </div>

    <Spacer size="10rem" />
  </div>
  <Spacer size="25rem" />
  <div class="section3">
    <Spacer size="3.3rem" />
    <h2 class="bold gray">
      <span style="color: #3cb043;">재배전문</span>은
      <span style="font-size: 1.3rem;">농장주에게,</span>
    </h2>
    <h2 class="bold gray">
      <span style="color: #0067a3;">자동시스템</span>은
      <span style="font-size: 1.3rem;">반딧불이에게!</span>
    </h2>
    <Spacer size="3.3rem" />
  </div>

  <div class="section4">
    <Spacer size="4rem" />
    <h1 style="color: #000;">아직도</h1>
    <p class="basicText">
      <span>이렇게 생활하신다면,<br />여러분은 어떻게 생각하십니까? </span>
    </p>
    <Spacer size="5rem" />
    <div style="width: 80%; margin: auto;">
      <ul style="padding-left: 0px !important;">
        <li>
          <p class="imgBox">
            <img src="/images/system/smartfarm/1/image1.gif" alt="지압" />
          </p>
          <dd>1. 하루종일 몸으로 하는 노동작업</dd>
        </li>
        <li>
          <p class="imgBox">
            <img src="/images/system/smartfarm/1/image1.gif" alt="지압" />
          </p>
          <dd>2. 매일 하우스 대기</dd>
        </li>
        <li />
        <li>
          <p class="imgBox">
            <img src="/images/system/smartfarm/1/image1.gif" alt="지압" />
          </p>
          <dd>3. 여유 없는 일상</dd>
        </li>
        <li />
        <li>
          <p class="imgBox">
            <img src="/images/system/smartfarm/1/image1.gif" alt="지압" />
          </p>
          <dd>4. 인력문제</dd>
        </li>
        <li />
      </ul>
    </div>
  </div>
  <div class="section5">
    <Spacer size="5rem" />
    <h1>그리고, 이런 경험도 있을 겁니다.!</h1>
    <Spacer size="3rem" />
    <div style="width: 95%;margin: 0 auto;">
      <img
        src="/images/system/smartfarm/1/experience.png"
        alt="경험1"
        style="width: 43%;"
      />
      <div style="display: inline-block;">
        <span class="experience_small"
          >오늘, 날씨도 좋고 하우스의 일도 어느정도 해놔서<br />
          근처 마실을 다녀올까..하고 자리를 잠시 비웠는데<br /><br />
          비로인해서 작물이 피해받는 경우..</span
        >
      </div>
    </div>
    <Spacer size="1rem" />
    <div style="width: 95%;margin: 0 auto;">
      <img
        src="/images/system/smartfarm/1/experience.png"
        alt="경험1"
        style="width: 43%;"
      />
      <div style="display: inline-block;">
        <span class="experience_small"
          >급히 하우스로 돌아가, 측창, 천창을 내리는 나의 모습을 보니<br />
          내가 이렇게 계속 살아야하나 싶더라구요.<br />
          작물이 피해는 없었는지 일일히 확인하는게 너무 스트레스 받습니다.</span
        >
      </div>
    </div>
    <Spacer size="3rem" />
  </div>

  <div class="section6">
    <Spacer size="5rem" />
    <h1 style="color: #000000;">재배, 불안함,<br />인력, 노동..</h1>
    <Spacer size="5rem" />
  </div>

  <div class="section7">
    <Spacer size="1rem" />
    <h1 style="color: #000000;">
      그런데 혹시,<br />
      이게 우리의 모습이진 않을까요?
    </h1>
    <Spacer size="1rem" />
  </div>

  <div class="section8">
    <Spacer size="5rem" />
    <div style="width: 65%;margin: 0 auto;">
      <img src="/images/system/smartfarm/1/inconvenience.png" alt="불편함" />
      <img src="/images/system/smartfarm/1/ready.png" alt="준비" />
    </div>
    <Spacer size="7rem" />

    <h2 style="color: #000000;">
      농가 상황을 <span class="bold">상담</span>받고,<br /> 환경에 맞는
      <span class="bold">시스템</span>을
      <span class="bold">세팅</span>하는 ICT전문가<br />
    </h2>
    <Spacer size="5rem" />
    <img src="/images/system/smartfarm/1/success.png" alt="성공하기" />
    <Spacer size="5rem" />
    <img
      src="/images/system/smartfarm/1/need_service.png"
      alt="제품이 필요한 사장님"
      style="width: 90%;"
    />
    <Spacer size="5rem" />
    <img
      src="/images/system/smartfarm/1/install_reason.png"
      alt="제품이 설치해야하는 이유"
      style="width: 65%;"
    />
    <Spacer size="5rem" />
    <img src="/images/system/smartfarm/1/review.png" alt="제품 사용 후기" />
  </div>
  <div class="section9">
    <Spacer size="5rem" />
    <div class="video" style="margin-top: 5px;">
      <div
        class="ytvideo-container"
        style="
    position: relative;
    width: 90%;
    margin: auto;
    height: auto;
    padding-top: 50%;
    "
      >
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/Mg4y-oq_Iqc"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen=""
          style="z-index: 1; top: 0; left: 0; position: absolute; width: 100%; height: 100%;"
        />
      </div>
    </div>
    <Spacer size="5rem" />
  </div>

  <div class="section10">
    <Spacer size="10rem" />
    <h1>반딧불이 원격제어의 핵심</h1>
    <h1 style="color: #3cb043">스마트팜 컨트롤 박스</h1>
    <Spacer size="5rem" />
    <img
      src="/images/system/smartfarm/1/bandi_introduce.png"
      alt="반딧불이 소개"
    />
    <Spacer size="5rem" />
    <img
      src="/images/system/smartfarm/1/system_type.png"
      alt="장치 타입"
      style="width: 60%;"
    />

    <Spacer size="5rem" />
    <img
      src="/images/system/smartfarm/1/data_process.png"
      alt="데이터 전송 단계"
    />
    <Spacer size="5rem" />
    <div style="padding-bottom: 5rem">
      <div class="background">
        <div style="margin: 0 auto;">
          <Spacer size="5rem" />
          <h2>
            <span style="color: #0067a3;">체계적인 농장 관리시스템</span>의
            관리팀 구성
          </h2>
          <div style="width: 80%; margin: 0 auto;">
            <ul>
              <li>
                <img
                  src="/images/system/smartfarm/1/b_icon1.png"
                  alt="연구팀"
                /><span>연구팀</span><span
                  >농업의 생태계 등 작물 연구, 원인분석 등 정부와 협력하여
                  새로운 정보 수집
                </span>
              </li>
              <li>
                <img
                  src="/images/system/smartfarm/1/b_icon2.png"
                  alt="개발팀"
                /><span>개발팀</span><span
                  >SW, HW, FW로 구성되어 있으며, 체계적인 시스템을 구축, 개발
                </span>
              </li>
              <li>
                <img
                  src="/images/system/smartfarm/1/b_icon3.png"
                  alt="생산팀"
                /><span>생산팀</span><span
                  >회로 설계, 분석 등 제품을 직접 생산하며, 농가 맞춤형으로
                  제작가능
                </span>
              </li>
              <li>
                <img
                  src="/images/system/smartfarm/1/b_icon4.png"
                  alt="설치/AS팀"
                /><span>설치/AS팀</span><span
                  >농가의 환경, 결과를 찾는 등 각기 다른 농가의 환경에 맞게 설치
                  및 문제 해결처리
                </span>
              </li>
              <li>
                <img
                  src="/images/system/smartfarm/1/b_icon5.png"
                  alt="전략팀"
                /><span>전략팀</span><span
                  >농업 트랜드 방향, 정보수집, 농가의 현황 파악 등 정보를
                  분석하며 새로운 시스템 구축
                </span>
              </li>
            </ul>
          </div>
          <div class="mt-4" style="padding-bottom: 5rem">
            <Button size="lg" color="dark" outline>견적 상담 신청하기</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<style lang="scss">
  .smart-main {
    text-align: center;
    width: 100%;
    margin-left: 50%;
    transform: translate(-50%, 10px);
  }
  .video {
    width: 80%;
    margin-left: 10%;
  }
  @media (min-width: 768px) {
    .smart-main {
      width: 1000px !important;
    }
    .video {
      width: 100% !important;
      margin-left: 0% !important;
    }
  }
  .video {
    padding: 0px;
  }
  .main h1 {
    padding: 0px 1rem 0px 1rem;
    font-size: 2rem;

    font-weight: bold;
    letter-spacing: -0.05em;
    color: #000;
    text-align: center;
    line-height: 4rem;
  }
  .main h2 {
    padding: 0px 1rem 0px 1rem;
    font-size: 2rem;
  }
  .sys {
    width: 80%;
    margin: auto;
  }

  .main .experience_small {
    display: inline-block;
    vertical-align: middle;
    width: auto;
    margin-top: 2rem;
    font-size: 1.2rem;
  }
  .background ul > li {
    width: 100%;
    float: left;
    margin-top: 2rem;
  }
  @media (min-width: 768px) {
    .background ul > li {
      width: 20%;
      float: left;
      margin-top: 0px;
    }
    // .video {
    //   padding: 0rem 15rem 0rem 15rem;
    // }
    .main h1 {
      padding: 0px !important;
      font-size: 3rem;
    }
    .main h2 {
      padding: 0px !important;
    }
    .sys {
      width: 100%;
      margin: auto;
    }
    .main .experience_small {
      display: inline-block;
      vertical-align: middle;
      width: 34rem;
      margin-top: 0px;
      font-size: 1.2rem;
    }
  }
  .background::after {
    display: table;
    content: "";
    clear: both;
  }
  .background ul {
    padding-top: 5rem;
    padding-left: 0px;
    display: table-cell;
  }

  .background ul > li > img {
    width: 40%;
    display: block;
    text-align: center;
    margin: 0 auto;
  }

  .background ul > li > span:nth-child(2) {
    display: block;
    width: 70%;
    margin: 0 auto;
    margin-top: 1rem;
  }
  .background ul > li > span:nth-child(3) {
    display: block;
    width: 70%;
    margin: 0 auto;
    margin-top: 2rem;
  }
  .background {
    background-image: url("/images/system/smartfarm/1/manage_bg.png");
    background-size: 100% 161%;
    width: 100%;
    height: 53%;
  }
  .gray {
    color: #808080;
  }
  .bandiimage > img {
    width: 100%;
  }

  .bold {
    font-weight: 600;
  }

  .section2 {
    background: #eee;
  }
  .section3 {
    background: #eee;
  }

  .section4 ul {
    display: flex;
    justify-content: space-between;
  }
  .section5 {
    background: #eee;
  }

  .section7 {
    background: #eee;
  }

  .section9 {
    background: #eee;
  }

  ul li {
    list-style: none;
  }
  .fontWL {
    font-weight: 200;
  }
  .bandiCont {
    width: 70%;
    margin: auto;
  }
  .bandi_image {
    width: 100%;
  }
  .basicText span {
    font-weight: 500;
  }

  .bandi_color {
    color: #cb1b21;
  }
  .main {
    color: #000;
  }

  .main .basicText {
    font-size: 1.2rem;
    font-weight: 200;
    letter-spacing: -0.05em;
    line-height: 2rem;
    color: #666;
    text-align: center;
  }
</style>
